// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '킴스제약',
  targetSheetName: '킴스제약 정책표 2025.12',
  headerRowIndex: 2,
  headerRowCount: 1,
  dataStartRowIndex: 3,
  columnMapping: {
    drugCode: '보험코드',
    drugName: '제품명',
    price: '약가',
    commissionRate: '정책',
    commissionNote: '비고',
  },
  requiredHeaders: [
    'NO',
    '분류',
    '성분명',
    '허가사',
    '제품명',
    '약가',
    '보험코드',
    '대조약',
    '정책',
    '비고',
  ],
});
